import Patrol from "../fragments/patrol";

export default `
query Patrol($patrolId: ID!) {
  getPatrol(patrolId: $patrolId) ${Patrol}
}
`;
